import { render, staticRenderFns } from "./ProducedPage.vue?vue&type=template&id=1bad9990&"
import script from "./ProducedPage.vue?vue&type=script&lang=js&"
export * from "./ProducedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports